import styled from "styled-components";
import { type SpaceProps, type BordersProps, space, borders } from "styled-system";

export const Wrapper = styled.div<SpaceProps & BordersProps>`
    display: flex;
    justify-content: space-between;
    font-size: 1.3rem;
    line-height: 2rem;
    border-color: ${({ theme }) => theme.color.grey3};
    user-select: none;
    ${space};
    ${borders};
`;

export const Title = styled.div`
    word-break: break-word;
    hyphens: auto;
`;

export const Subtitle = styled.div`
    color: ${({ theme }) => theme.textColor.muted};
`;

export const Min = styled.div`
    padding-right: 6px;

    ${Title},
    ${Subtitle} {
        text-align: start;
    }

    html[dir="rtl"] & {
        padding-left: 6px;
        padding-right: 0;
    }
`;

export const Max = styled.div`
    padding-left: 6px;

    ${Title},
    ${Subtitle} {
        text-align: end;
    }

    html[dir="rtl"] & {
        padding-left: 0;
        padding-right: 6px;
    }
`;
